import { useState, useCallback } from "react";
import { HEIGHT_UNITS } from "../../utils/calculators/constants";


// Provides consistent height input state and handlers across all calculators 
export const useHeightInput = (defaultUnit = "cm") => {
  const [heightValue, setHeightValue] = useState("");
  const [heightUnit, setHeightUnit] = useState(defaultUnit);
  const [feetValue, setFeetValue] = useState("");
  const [inchesValue, setInchesValue] = useState("");

  const clearHeightError = useCallback((setErrors) => {
    if (setErrors) {
      setErrors((prev) => ({ ...prev, height: "" }));
    }
  }, []);

  const handleHeightChange = useCallback(
    (e, setErrors) => {
      setHeightValue(e.target.value.replace(/^0+/, ""));
      clearHeightError(setErrors);
    },
    [clearHeightError],
  );

  const handleFeetChange = useCallback(
    (e, setErrors) => {
      setFeetValue(e.target.value.replace(/^0+/, ""));
      clearHeightError(setErrors);
    },
    [clearHeightError],
  );

  const handleInchesChange = useCallback(
    (e, setErrors) => {
      setInchesValue(e.target.value.replace(/^0+/, ""));
      clearHeightError(setErrors);
    },
    [clearHeightError],
  );

  const handleHeightUnitChange = useCallback(
    (e, setErrors) => {
      const newUnit = e.target.value;
      if (newUnit !== heightUnit) {
        // clear all height fields when switching units
        setHeightValue("");
        setFeetValue("");
        setInchesValue("");
      }
      setHeightUnit(newUnit);
      clearHeightError(setErrors);
    },
    [heightUnit, clearHeightError],
  );

  const clearHeightFields = useCallback(() => {
    setHeightValue("");
    setFeetValue("");
    setInchesValue("");
    setHeightUnit(defaultUnit);
  }, [defaultUnit]);

  return {
    heightValue,
    heightUnit,
    feetValue,
    inchesValue,

    handleHeightChange,
    handleFeetChange,
    handleInchesChange,
    handleHeightUnitChange,
    clearHeightFields,

    setHeightValue,
    setHeightUnit,
    setFeetValue,
    setInchesValue,

    unitOptions: HEIGHT_UNITS,
    height: heightValue,
    feet: feetValue,
    inches: inchesValue,
    handleUnitChange: handleHeightUnitChange,
  };
};

export default useHeightInput;
